var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ../~/gatsby/~/lodash/_Uint8Array.js
// module id = 312
// module chunks = 0